import { selectBadge } from "@faire/retailer-visitor-shared/components/ProductBadge/badgeUtils";
export var productTileTopBadgesPropsILeanProductTileAdapter = function(productTile) {
    var _productTile_badge_list, _productTile_product;
    var _productTile_badge_list_badges;
    return {
        showEventBadge: productTile.is_highlighted_product_for_promotional_event,
        topBadge: selectBadge((_productTile_badge_list_badges = (_productTile_badge_list = productTile.badge_list) === null || _productTile_badge_list === void 0 ? void 0 : _productTile_badge_list.badges) !== null && _productTile_badge_list_badges !== void 0 ? _productTile_badge_list_badges : [], "TOP"),
        hideBadge: !productTile.product,
        productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        badgeList: productTile.badge_list
    };
};
